
// Test data for Level 3 Putting Training

export const puttingTests = [
  {
    id: "putts-plat",
    title: "Les putts à plat",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles aux points A=0,5m, B=0,8m, C=1m et jouer successivement. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-montee",
    title: "Les putts en montée",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en montée sur les points A1=0,5, B1=0,8, C1=1m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-descente",
    title: "Les Putts en descente",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en descente aux points A2=0,5, B2=0,8, C2=1m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-pente",
    title: "Les Putts en Pente gauche droite",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en pente gauche droite aux points A3=0,5, B3=0,8, C3=1m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-pente-droite",
    title: "Les Putts en Pente droite gauche",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en pente droite gauche aux points A4=0,5, B4=0,8, C4=1m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  }
];
